const WORK_DAYS = 0
const WORK_TIME = 1
const AUTO_ANSWER = 2
module.exports = {
    settingPublicWorkDays: WORK_DAYS,
    settingPublicWorkTime: WORK_TIME,
    settingPublicAutoAnswer: AUTO_ANSWER,
    emailSimple: 0,
    showCountItems: 1,
    promo: 2,
    emptyImage: 3,
    groupItems: 4,
    addWeightToKeyboard: 5,
    stockQuantity: 6,
    buttonCancelOrder: 7,
    buttonStatusPay: 8,
    buttonDeleteMessage: 9,
    checkoutInline: 10,
    basketOff: 11,
    secretClientOn: 12,
    checkoutButton: 13,
    clientNameNotEdit: 14,
    hideHelpInClientBox: 15,
    showBalance: 16,
    showPayButton: 17
}
